import TextArea from 'components/Form/TextArea'
import { FormItem } from 'components/UIComponents/FormStyles'
import {
  CommonFlex,
  DetailsDiv,
  StrenthDiv,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/style'
import React from 'react'

const UpdateSelected = () => {
  return (
    <CommonFlex>
      <FormItem>
        <StrenthDiv>
          <DetailsDiv>Strengths</DetailsDiv>
          <TextArea placeholder="Add Strengths" name={'strength'} />
        </StrenthDiv>
      </FormItem>

      <FormItem>
        <StrenthDiv>
          <DetailsDiv>Weakness</DetailsDiv>
          <TextArea placeholder="Add Weakness" name={'weakness'} />
        </StrenthDiv>
      </FormItem>
    </CommonFlex>
  )
}

export default UpdateSelected
